import { FunctionComponent, useState } from 'react'
import SupportDialog from '../Dialog/supportDialog'
import { useAuth } from '@/modules/context/AuthContext'
import Desktop from '@/modules/desktopMobile/desktop'
import Mobile from '@/modules/desktopMobile/mobile'
import CALDHomeDesktop from './CALDHomeDesktop'
import CALDHomeMobile from './CALDHomeMobile'

interface CALDHomeProps {
    backendVersion: string
    frontendVersion: string
}

const CALDHome: FunctionComponent<CALDHomeProps> = ({ backendVersion, frontendVersion }: CALDHomeProps) => {
    const { user } = useAuth()

    const [isDialogSupportOpen, setDialogSupportOpen] = useState<boolean>(false)

    return (
        <>
            <Desktop>
                <CALDHomeDesktop
                    backendVersion={backendVersion}
                    frontendVersion={frontendVersion}
                    setDialogSupportOpen={setDialogSupportOpen}
                />
            </Desktop>
            <Mobile>
                <CALDHomeMobile
                    backendVersion={backendVersion}
                    frontendVersion={frontendVersion}
                    setDialogSupportOpen={setDialogSupportOpen}
                />
            </Mobile>
            <SupportDialog
                open={isDialogSupportOpen}
                handleClose={(): void => setDialogSupportOpen(false)}
                email={user?.email || ''}
            />
        </>
    )
}

export default CALDHome
